import script from "./MySubscriptions.vue?vue&type=script&setup=true&lang=js"
export * from "./MySubscriptions.vue?vue&type=script&setup=true&lang=js"

import "./MySubscriptions.vue?vue&type=style&index=0&id=137aeb41&lang=scss&scoped=true"

import exportComponent from "/builds/p3839/client-suite/proxima_blue2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-137aeb41"]])

export default __exports__